/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */
    categories: {
        edit: 'Edit categories',
    },

    /* Module special vocabulary */
    media: {
        menu: {
            create: 'add a photo',
        }
    },

    helps: {
        menu: {
            index: 'Help & Support',
            create: 'New article',
            list: 'Help articles',
            'categories-create': 'Create a category',
            'categories-list': 'Categories',
        },
        table_titles: {
            id: 'ID',
            title: 'Subject',
            slug: 'Slug',
            order: 'Order',
            description: 'Description',
            tags: 'Tags',
            category: {
                id: 'ID',
                title: 'Category name',
                slug: 'Slug',
                order: 'Order',
                icon: 'Icon',
                description: 'Summary',
                setting: 'Edit / Delete',
            },
            setting: 'Edit / Delete'
        },
        faq_about: 'Frequently Asked Questions About',
        header_title: 'Help & Support',
        search_placeholder: 'Start by typing your keywords...',
        search_hint: 'Need help?',
        view: 'View',
        edit: 'Edit the article'
    }
}
